import { useTranslation } from 'react-i18next';
import React from "react";
import { Form, Switch } from "antd";

export const __FormSwitch = (props) => {
    const { t } = useTranslation()
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            valuePropName="checked"
        >
            <Switch
                checkedChildren={props.checkedChildren || t(`erpcomponents.item.FormSwitch.开启`)}
                unCheckedChildren={props.unCheckedChildren || t(`erpcomponents.item.FormSwitch.关闭`)}
                disabled={props.disable}
            />
        </Form.Item>
    )
}